// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Arrow_wrapper__2CfPR","img":"Arrow_img__2sOx2","left":"Arrow_left__1gug2","right":"Arrow_right__kwg_s","show":"Arrow_show__1AX2j","hide":"Arrow_hide__2GAQk"};